import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e6f0367"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fieldset__row fieldset__row--3" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = {
  key: 1,
  disabled: ""
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  value: '',
  selected: ""
}
const _hoisted_8 = ["value", "selected"]
const _hoisted_9 = {
  key: 1,
  disabled: ""
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  value: '',
  selected: ""
}
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 1,
  disabled: ""
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "JobBoardForm form",
    onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.country')), 1),
        (_ctx.jobPage)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.countryId) = $event)),
              name: "country",
              disabled: _ctx.isLoading
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobPage.countries, (countryItem) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: countryItem.id,
                  value: countryItem.id,
                  selected: countryItem.id == _ctx.countryId
                }, _toDisplayString(countryItem.name), 9, _hoisted_3))
              }), 128))
            ], 8, _hoisted_2)), [
              [
                _vModelSelect,
                _ctx.countryId,
                void 0,
                { number: true }
              ]
            ])
          : (_openBlock(), _createElementBlock("select", _hoisted_4)),
        _hoisted_5
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.state')), 1),
        (_ctx.jobPage)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.stateId) = $event)),
              disabled: _ctx.countryId !== 230 || !_ctx.jobPage.states || _ctx.jobPage.states.length === 0 || _ctx.isLoading,
              name: "state"
            }, [
              _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t('profileEdit.all')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobPage.states, (stateItem) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: stateItem.id,
                  value: stateItem.id,
                  selected: stateItem.id == _ctx.stateId
                }, _toDisplayString(stateItem.name), 9, _hoisted_8))
              }), 128))
            ], 8, _hoisted_6)), [
              [
                _vModelSelect,
                _ctx.stateId,
                void 0,
                { number: true }
              ]
            ])
          : (_openBlock(), _createElementBlock("select", _hoisted_9)),
        _hoisted_10
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('profileEdit.city')), 1),
        (_ctx.jobPage)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cityId) = $event)),
              disabled: _ctx.countryId !== 230 || !_ctx.jobPage.cities || _ctx.jobPage.cities.length === 0 || _ctx.isLoading,
              name: "city"
            }, [
              _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('profileEdit.all')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobPage.cities, (cityItem) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: cityItem.id,
                  value: cityItem.id
                }, _toDisplayString(cityItem.name), 9, _hoisted_13))
              }), 128))
            ], 8, _hoisted_11)), [
              [
                _vModelSelect,
                _ctx.cityId,
                void 0,
                { number: true }
              ]
            ])
          : (_openBlock(), _createElementBlock("select", _hoisted_14)),
        _hoisted_15
      ])
    ])
  ], 32))
}